import { render, staticRenderFns } from "./TaskActivities.vue?vue&type=template&id=7bcdc2ba&scoped=true"
import script from "./TaskActivities.vue?vue&type=script&lang=js"
export * from "./TaskActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcdc2ba",
  null
  
)

export default component.exports